export enum DocRebootSupportMode {
  NotSupported = 0,
  SameDocOnly = 1,
  AnyDoc = 1 << 1,
  OtherMode = 1 << 2,
}
